import { Button, Modal, Table } from '@octano/global-ui';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { CardTitle } from '../../../../components/text';
import { TranslationsKeys } from '../../../../locales/translations';
import { useModalColumns } from '../hooks/useModalColumns';
import { PerformanceAnalysisDetailRowModalData } from '../types';

interface PerformanceAnalysisTableModalProps {
  onClose: (result: boolean) => void;
  data: PerformanceAnalysisDetailRowModalData;
}

export function PerformanceAnalysisTableModal(
  props: PerformanceAnalysisTableModalProps,
) {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS,
  );
  const { onClose, data } = props;

  const table = useMemo(() => {
    return t<
      string,
      {
        title: {
          studyPlanVersions: string;
          teachers: string;
        };
        close: string;
      }
    >('tableModal', {
      returnObjects: true,
    });
  }, [t]);

  const colums = useModalColumns({ data });

  const close = useCallback(() => {
    onClose(false);
  }, [onClose]);

  return (
    <Modal isOpen size="md" toggle={close}>
      <CardTitle children={table.title[props.data.type]} textCenter />
      <Table
        columns={colums}
        data={data.params}
        borderless={false}
        color="transparent"
        striped
      />
      <Row className="pt-5">
        <Col className="ml-auto">
          <div>
            <Button
              type="button"
              text={table.close}
              onClick={close}
              outlined
              fullwidth
            />
          </div>
        </Col>
      </Row>
    </Modal>
  );
}
